// src/app/shared/components/dlg-confirm/dlg-confirm.component.ts
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

export enum AlertType {
  info = 'info',
  warning = 'warning',
  error = 'error',
  success = 'success',
  none = 'none',
}

@Component({
  selector: 'app-dlg-confirm',
  standalone: true,
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './dlg-confirm.component.html',
  styleUrl: './dlg-confirm.component.css',
})
export class DlgConfirmComponent {
  readonly dialogRef = inject(MatDialogRef<DlgConfirmComponent>);
  readonly data = inject<any>(MAT_DIALOG_DATA);

  title: string;
  description: string = 'Are you sure you want to proceed?';
  showType?: AlertType = AlertType.warning;
  action: string = 'Yes';
  cancelText: string = 'Cancel';
  buttonColor: string = 'bg-primary-500';
  buttonTextColor: string = 'text-white';

  showCancel: boolean = true;

  alertType = AlertType;

  constructor() {
    this.title = this.data?.title ?? '';
    this.description =
      this.data?.description ??
      this.data?.message ??
      'Are you sure you want to proceed?';
    this.action = this.data?.action ?? 'Confirm';
    this.cancelText = this.data?.cancelText ?? 'Cancel';
    this.buttonColor = this.data?.buttonColor ?? 'bg-primary-500';
    this.buttonTextColor = this.data?.buttonTextColor ?? 'text-white';
    this.showType =
      this.data?.showType ?? this.data?.alertType ?? AlertType.warning;
    this.showCancel = this.data?.showCancel ?? true;
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  submit(): void {
    this.dialogRef.close(true);
  }

  // Helper for the icon that matches the type
  get iconName(): string {
    switch (this.showType) {
      case AlertType.error:
        return 'error';
      case AlertType.success:
        return 'check_circle';
      case AlertType.warning:
        return 'warning';
      case AlertType.info:
        return 'info';
      default:
        return 'help';
    }
  }
}
